import difference from 'lodash/difference';

import { mdiLibraryBooks } from '@lumapps/lumx/icons';
import { HTML_ALLOWED_ATTRIBUTES, HTML_ALLOWED_TAGS } from '@lumapps/widget-html/constants';

export const WIDGET_CONTENT_LIST_TYPE = 'content-list';
export const WIDGET_CONTENT_LIST_ICON = mdiLibraryBooks;
export const WIDGET_CONTENT_LIST_EDITION_SCOPE = 'widget-content-list-edition';

export const CONTENT_LIST_HTML_ALLOWED_TAGS = difference(
    HTML_ALLOWED_TAGS,
    // Exclude tags that are not allowed in content list
    ['script', 'style', 'embed'],
);

export const CONTENT_LIST_HTML_ALLOWED_ATTRIBUTES = [...HTML_ALLOWED_ATTRIBUTES];
